import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl }) => {
  return (
    <Col size={8} sm={12} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} width={"12px"} />
        <div className="proj-txtx">
          <h4 style={{ color: "black" }}>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  );
};
